import React from "react";
import "./What_Will_Learn.css";
import { IDS } from "../../../utils/IDS";

const What_Will_Learn = ({ program }) => {
  const programData = Array.isArray(program) ? program[0] : program;

  const whatlearn = programData?.whatlearn || [];

  return (
    <section className="What_Will_Learn">
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-md-7 mb-3">
            <div className="what_learn_left_div">
              <h5 className="what_learn_title">
                What You <span>Will Learn</span>
              </h5>

              {/* DESCRIPTION */}
              {whatlearn.length > 0 && (
                <p className="what_learn_text">{whatlearn?.[0]?.description}</p>
              )}

             
            </div>
          </div>

          <div className="col-lg-5 col-md-5 mb-3">
            <div className="right_img_holder">
              {whatlearn.length > 0 && whatlearn[0]?.image && (
                <img
                  src={`${IDS.IMG_URL}${whatlearn[0]?.image}`}
                  alt="what-learn"
                  className="right_img"
                />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 mb-3">
            <div className="blue_div_holder">
                <div className="blue_left_div">
                  <h5 className="blue_title">Who is this for?</h5>
                  {whatlearn.length > 0 &&
                    whatlearn[0]?.who_is_fors?.map((item) => (
                      <li key={item.id} className="blue_list">
                        {item.title}
                      </li>
                    ))}
                </div>

                <div className="blue_left_div">
                  <h5 className="blue_title">Career Roles</h5>

                  {whatlearn.length > 0 &&
                    whatlearn[0]?.career_roles?.map((item) => (
                      <li key={item.id} className="blue_list">
                        {item.title}
                      </li>
                    ))}
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default What_Will_Learn;
